// src/pages/DashboardPage/index.js

import React from 'react';
import { Card, Avatar, Typography, Descriptions, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';

const { Title, Text } = Typography;

const DashboardPage = () => {
  const { currentUser, userRole, loading } = useAuth();

  if (loading || !currentUser) {
    return <Spin size="large" style={{ display: 'block', marginTop: '50px' }} />;
  }

  // --- THAY ĐỔI: TẠO DỮ LIỆU HIỂN THỊ DỰA TRÊN VAI TRÒ ---
  let descriptionItems = [];
  const isStudent = currentUser.userType === 'student';

  if (isStudent) {
    // Dữ liệu cho học sinh
    descriptionItems = [
      {
        key: '1',
        label: '学籍番号',
        children: currentUser.studentId || 'N/A',
      },
      {
        key: '2',
        label: '年度・クラス',
        children: currentUser.className || 'N/A',
      },
      {
        key: '3',
        label: '出席番号',
        children: currentUser.regNumber || 'N/A',
      },
      {
        key: '4',
        label: 'Email',
        children: currentUser.email || 'N/A',
      },
      {
        key: '5',
        label: '役割',
        children: userRole?.name || '未割り当て',
      },
    ];
  } else {
    // Dữ liệu cho Admin và Giáo viên
    descriptionItems = [
        {
            key: '1',
            label: '氏名',
            children: currentUser.nameRomaji || 'N/A',
        },
        {
            key: '2',
            label: '担任クラス',
            children: currentUser.homeroomClass || 'N/A',
        },
        {
            key: '3',
            label: '役割',
            children: userRole?.name || '未割り当て',
        },
        {
            key: '4',
            label: 'メール (Login ID)',
            children: currentUser.email || 'N/A',
        },
    ];
  }

  return (
    <div>
      <Title level={2}>ホームページ</Title>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
          <Avatar size={80} src={currentUser.avatar} icon={<UserOutlined />} />
          <div style={{ marginLeft: '24px' }}>
            <Title level={3} style={{ margin: 0 }}>
              {currentUser.nameRomaji || currentUser.fullName}
            </Title>
            {currentUser.nameKatakana && <Text type="secondary">{currentUser.nameKatakana}</Text>}
          </div>
        </div>
        <Descriptions 
          bordered 
          column={1} 
          title="個人情報"
          items={descriptionItems} 
        />
      </Card>
    </div>
  );
};

export default DashboardPage;